import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Layout } from "@/components/Layout/Layout";
import { Header } from "@/components/Header/Header";
import { Loading } from "@/components/Loading/Loading";
import { ErrorState } from "@/components/ErrorState/ErrorState";
import { lessonApi } from "@/services/lessonApi";
import type { LessonDetail } from "@/types/lesson";

export function LessonDetails() {
  const { lessonId } = useParams();
  const navigate = useNavigate();
  const [lesson, setLesson] = useState<LessonDetail | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!lessonId) return;
    lessonApi
      .getLesson(lessonId)
      .then(setLesson)
      .catch(() => setError(true));
  }, [lessonId]);

  return (
    <Layout>
      <Header title="Lesson" showBack />
      <main className="flex flex-1 flex-col items-center gap-6 p-6">
        {error && <ErrorState message="We couldn't load this lesson." />}
        {!lesson && !error && <Loading label="Loading lesson details..." />}
        {lesson && (
          <div className="w-full max-w-md rounded-3xl bg-white p-6 text-center shadow-md">
            <img
              src={lesson.thumbnail}
              alt=""
              className="mb-4 h-40 w-full rounded-2xl object-cover"
            />
            <h2 className="text-2xl font-extrabold text-slate-800">
              {lesson.title}
            </h2>
            <p className="mt-1 text-slate-500">
              {lesson.subject} · Grade {lesson.grade} · {lesson.duration} min
            </p>
            {lesson.description && (
              <p className="mt-3 text-slate-600">{lesson.description}</p>
            )}
            <button
              type="button"
              onClick={() => navigate(`/player/${lesson.lessonId}`)}
              className="mt-6 w-full rounded-full bg-emerald-500 py-3 text-lg font-extrabold text-white active:scale-95"
            >
              {lesson.completed ? "Play Again" : "Start Lesson"}
            </button>
          </div>
        )}
      </main>
    </Layout>
  );
}
